import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#ADD391" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center black bold>
            <CFLink href="https://www.facebook.com/wasabivernon/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Wasabi Sushi & Grill Facebook"
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/wasabivernon/?igsh=dzZwMTZ0OGI5bzU2#">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Wasabi Sushi & Grill Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#ADD391" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter black bold>
            <CFLink href="https://www.facebook.com/wasabivernon/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Wasabi Sushi & Grill Facebook"
                hover
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/wasabivernon/?igsh=dzZwMTZ0OGI5bzU2#">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Wasabi Sushi & Grill Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
